import { Injectable } from '@angular/core';
import { DataService } from '../core/interceptor.service';
import { KRONOS } from '../../../app-constants';
import { API } from '../../../constants/index';

@Injectable()
export class AccountsService {
  account: any = {};

  constructor(private dataService: DataService) { }

  getAll() {
    const req = {
    }
    return this.dataService.post(KRONOS.BASE + KRONOS.USER + API.GET_ALL_ACCOUNTS, req);
  }

  getAllAccountProjects(id) {
    const req = {
      id: id
    }
    return this.dataService.post(KRONOS.BASE + KRONOS.USER + API.GET_ALL_ACCOUNT_PROJECTS, req);
  }

  getAllCountry() {
    const req = {
    }
    return this.dataService.post(KRONOS.BASE + KRONOS.USER + API.GET_ALL_COUNTRIES, req);
  }

  addNew(account) {
    return this.dataService.post(KRONOS.BASE + KRONOS.USER + API.ADD_NEW_ACCOUNT, account);
  }

  updateAccount(account) {
    return this.dataService.post(KRONOS.BASE + KRONOS.USER + API.UPDATE_ACCOUNT, account);
  }

  deleteAccount(id) {
    const req = {
      id: id
    }
    return this.dataService.post(KRONOS.BASE + KRONOS.USER + API.DELETE_ACCOUNT, req);
  }

  getAccountTags(req) {
    return this.dataService.post(KRONOS.BASE + KRONOS.TAG + API.SEARCH_TAGS, req);
  }

  addAccountTags(req) {
    return this.dataService.post(KRONOS.BASE + KRONOS.TAG + API.ADD_ENTITY_TAGS, req);
  }

  updateAccountTags(req) {
    return this.dataService.post(KRONOS.BASE + KRONOS.TAG + API.UPDATE_ENTITY_TAGS, req);
  }

  removeAccountTags(req) {
    return this.dataService.post(KRONOS.BASE + KRONOS.TAG + API.REMOVE_ENTITY_TAGS, req);
  }

  getAccountClassificationsByType(type) {
    return this.dataService.get(KRONOS.BASE + KRONOS.ADMIN + API.GET_ACCOUNT_CLASSIFICATIONS_BY_TYPE + type);
  }

  addAccountClassification(req) {
    return this.dataService.post(KRONOS.BASE + KRONOS.ADMIN + API.ACCOUNT_CLASSIFICATIONS, req);
  }

  updateAccountClassification(req, id) {
    return this.dataService.patch(KRONOS.BASE + KRONOS.ADMIN + API.ACCOUNT_CLASSIFICATIONS + "/" + id, req);
  }

  deleteAccountClassification(id) {
    const options = {};
    return this.dataService.deletePlain(KRONOS.BASE + KRONOS.ADMIN + API.ACCOUNT_CLASSIFICATIONS + "/" + id);
  }
}
